import { useRef } from 'react';
import { InputGroup, Input } from 'rsuite';
import { icons } from '@shared/static/icons';

export default function SearchTableLocal({ value, onChange, placeholder }) {
  const inputRef = useRef(null);

  const onClean = () => {
    inputRef.current?.focus();
    onChange('');
  };

  return (
    <div className="search-group">
      <InputGroup className={value ? 'has-value' : ''}>
        <Input
          ref={inputRef}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
        {value ? (
          <InputGroup.Button tabIndex={-1} onClick={onClean}>
            {icons.close}
          </InputGroup.Button>
        ) : (
          <InputGroup.Button>{icons.search}</InputGroup.Button>
        )}
      </InputGroup>
    </div>
  );
}
